import { FontSizeTheme } from '@kite-js/theme-types';

const basicLineHeights: FontSizeTheme = {
    XXXXL: '68px',
    XXXL: '50px',
    XXL: '30px',
    XL: '26px',
    L: '24px',
    M: '20px',
    S: '16px',
    XS: '14px',
};

export default basicLineHeights;
